import React from 'react';
import { ButtonDesignType } from '@typings/setting/homepageSetting.interface';
import {
  DefaultButton,
  DiaButton,
  CircleButton,
  SlideButton,
  RuneButton,
  PixelButton,
  CrystalButton,
  ButtonDesignProps,
} from './ButtonDesigns';

export type { ButtonDesignProps };

export const BUTTON_DESIGNS: {
  type: ButtonDesignType;
  name: string;
  component: React.FC<ButtonDesignProps>;
  pairName: string;
}[] = [
  { type: 'default',      name: '기본',           component: DefaultButton, pairName: '-' },
  { type: 'diaButton',    name: '다이아 버튼',    component: DiaButton,    pairName: '다이아 애로우' },
  { type: 'circleButton', name: '서클 버튼',      component: CircleButton, pairName: '서클 애로우' },
  { type: 'slideButton',  name: '슬라이드 버튼',  component: SlideButton,  pairName: '슬라이드 애로우' },
  { type: 'runeButton',   name: '룬 버튼',        component: RuneButton,   pairName: '룬 애로우' },
  { type: 'pixelButton',  name: '픽셀 버튼',      component: PixelButton,  pairName: '픽셀 애로우' },
  { type: 'crystalButton',name: '크리스탈 버튼',  component: CrystalButton,pairName: '크리스탈 애로우' },
];

export function getButtonDesignComponent(
  designType: ButtonDesignType = 'default',
): React.FC<ButtonDesignProps> {
  const found = BUTTON_DESIGNS.find((d) => d.type === designType);
  return found ? found.component : DefaultButton;
}
